import API from 'services/API';
import { formatAddress } from 'utils';

export default function getTaxAuthorityAffiliates(parentId) {
  return API.request({
    method: 'GET',
    url: `/appointment/getTorm?parentId=${parentId}`,
    mapper: function (data = []) {
      return data.map((taxAuthority) => {
        return {
          address: formatAddress(taxAuthority.contacts),
          ...taxAuthority,
        };
      });
    },
  });
}
